import {useUpdateCompanyMemberPermissionMutation} from "@/api/companyApi";
import UserAvatarPlaceholder from "@/assets/images/user_avatar_placeholder.svg";
import Modal from "@/components/Common/Modal";
import type {TAccountMember} from "@/store/types";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const ChangeAccountOwnershipModal: FC<{
  companyId: number;
  companyMember: TAccountMember;
  onClose: () => void;
}> = ({companyId, companyMember, onClose}) => {
  const {t} = useTranslation("multi_account");

  const {mutate: updatePermission} = useUpdateCompanyMemberPermissionMutation({
    companyMemberUserId: companyMember.user.id,
    companyId: companyId,
  });

  return (
    <Modal
      backgroundClassName="max-w-150"
      modalTitle={t("change_account_ownership")}
      onClose={onClose}
      onConfirm={() => updatePermission({newPermission: "ADMIN"})}>
      <div className="flex flex-col items-center gap-5">
        <span className="text-neutral-black">{t("change_account_ownership_to")}</span>
        <div className="border-neutral-grey-light-dark flex items-center gap-2 rounded-full border p-1 pr-2">
          <div className="size-6 shrink-0 rounded-full">
            <img
              src={companyMember?.user.profile_picture ?? UserAvatarPlaceholder}
              className="h-full w-full rounded-full"
            />
          </div>
          <span className="bg-linear-(--primary-dark-gradient) bg-clip-text font-semibold text-transparent">
            {companyMember?.user.first_name} {companyMember?.user.last_name}
          </span>
        </div>
        <div className="bg-warning-light-yellow flex flex-col items-center gap-2 self-stretch rounded-md px-4 py-5">
          <span className="text-warning-dark-yellow text-lg font-semibold">
            {t("change_account_ownership_warning_title")}
          </span>
          <span className="text-neutral-black text-xs">{t("change_account_ownership_warning_subtitle")}</span>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeAccountOwnershipModal;
